// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fMAp","name":"styles_name__2LWDh","phone":"styles_phone__3BZSv"};